// extracted by mini-css-extract-plugin
export default {"searchBoxCon":"UniVersialSearchModal_searchBoxCon__pGXGX","arrowIcon":"UniVersialSearchModal_arrowIcon__d1HCx"};